// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadMoreObserver_root__1g2F6","rootCenter":"LoadMoreObserver_rootCenter__8WvHd","noPaddingBottom":"LoadMoreObserver_noPaddingBottom__3zySE"};